import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

interface RateSourceIndicatorProps {
  isLive: boolean;
  className?: string;
}

export const RateSourceIndicator: React.FC<RateSourceIndicatorProps> = ({ 
  isLive, 
  className = '' 
}) => {
  if (isLive) {
    return (
      <span className={`text-xs flex items-center gap-1 text-green-600 dark:text-green-400 ${className}`}>
        <Wifi className="h-3 w-3" />
        Live Market Rate
      </span>
    );
  }

  return (
    <span className={`text-xs flex items-center gap-1 text-amber-600 dark:text-amber-400 ${className}`}>
      <WifiOff className="h-3 w-3" />
      Default Rate
    </span>
  );
};
